import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const AdminNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isActive = (path) => (
    location.pathname === path
    || (path === '/admin/conversations' && location.pathname.startsWith('/admin/offers/'))
  );

  const linkClass = (path) =>
    `px-4 py-2 rounded-lg text-sm font-medium ${
      isActive(path)
        ? 'bg-blue-600 text-white'
        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
    }`;

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex flex-wrap gap-2">
        <Link to="/admin/chatbots" className={linkClass('/admin/chatbots')}>
          {t('admin.nav.chatbots')}
        </Link>
        <Link to="/admin/prompts" className={linkClass('/admin/prompts')}>
          {t('admin.nav.prompts')}
        </Link>
        <Link to="/admin/conversations" className={linkClass('/admin/conversations')}>
          {t('admin.nav.conversations')}
        </Link>
        <Link to="/admin/monitoring" className={linkClass('/admin/monitoring')}>
          {t('admin.nav.monitoring')}
        </Link>
        <Link to="/admin/analytics" className={linkClass('/admin/analytics')}>
          {t('admin.nav.analytics')}
        </Link>
        <Link to="/admin/documentation" className={linkClass('/admin/documentation')}>
          {t('admin.nav.documentation')}
        </Link>
      </div>
    </div>
  );
};

export default AdminNav;
